import { Alert, Box, Button, Grid, Tab, Tabs } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import {
    DataGridPro,
    GridToolbarContainer,
    GridToolbarQuickFilter,
    itIT,
} from '@mui/x-data-grid-pro';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import {
    QueryClient,
    QueryClientProvider,
    useQuery,
} from '@tanstack/react-query';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import unsplash from '../api/unsplash';
import { CustomFooterPersonalized } from '../utils/CustomFooterPersonalizedNoExport';

import {
    ArrowDropDown,
    ArrowDropUp,
    Dataset,
    FileDownload,
} from '@mui/icons-material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import {
    ButtonGroup,
    ClickAwayListener,
    Grow,
    MenuItem,
    MenuList,
    Paper,
    Popper,
} from '@mui/material';
import { useRef } from 'react';
import * as XLSX from 'sheetjs-style';

import jsPDF from 'jspdf';

const stats = [
    {
        name: 'Statistiche per ore',
        inner: [
            {
                name: 'Ore per genere',
                columns: [
                    {
                        field: 'Sesso',
                        headerName: 'Genere',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                    {
                        field: 'Ore_Corso',
                        headerName: 'Ore Corso',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                ],
                endpoint: 'statisticheFormazione/orePerGenere',
            },
            {
                name: 'Ore per inquadramento',
                columns: [
                    {
                        field: 'Qualifica',
                        headerName: 'Qualifica',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                    {
                        field: 'Ore_Corso',
                        headerName: 'Ore Corso',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                ],
                endpoint: 'statisticheFormazione/orePerInquadramento',
            },
            {
                name: 'Ore per ambito',
                columns: [
                    {
                        field: 'Ambito',
                        headerName: 'Ambito',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                    {
                        field: 'Ore_Corso',
                        headerName: 'Ore Corso',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                ],
                endpoint: 'statisticheFormazione/orePerAmbito',
            },
            {
                name: 'Ore-Ambiti-Inquadramento',
                columns: [
                    {
                        field: 'Ambito',
                        headerName: 'Ambito',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                    {
                        field: 'Sesso',
                        headerName: 'Genere',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                    {
                        field: 'Qualifica',
                        headerName: 'Qualifica',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                    {
                        field: 'Ore_Corso',
                        headerName: 'Ore Corso',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                ],
                endpoint: 'statisticheFormazione/oreAmbitiInquadramento',
            },
            {
                name: 'Ore per tipo categoria',
                columns: [
                    {
                        field: 'TipoCategoria',
                        headerName: 'Tipo Categoria',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                    {
                        field: 'Ore_Corso',
                        headerName: 'Ore Corso',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                ],
                endpoint: 'statisticheFormazione/orePerTipoCategoria',
            },
            {
                name: 'Ore-TipoCategoria-Inquadramento',
                columns: [
                    {
                        field: 'TipoCategoria',
                        headerName: 'Tipo Categoria',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                    {
                        field: 'Sesso',
                        headerName: 'Genere',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                    {
                        field: 'Qualifica',
                        headerName: 'Qualifica',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                    {
                        field: 'Ore_Corso',
                        headerName: 'Ore Corso',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                ],
                endpoint: 'statisticheFormazione/oreTipoCategoriaInquadramento',
            },
        ],
    },
    {
        name: 'Statistiche per lavoratore',
        inner: [
            {
                name: 'Lavoratori per genere',
                columns: [
                    {
                        field: 'Sesso',
                        headerName: 'Genere',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                    {
                        field: 'numeroLavoratoriRaggiunti',
                        headerName: 'Lavoratori Raggiunti',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                ],
                endpoint: 'statisticheFormazione/lavoratoriPerGenere',
            },
            {
                name: 'Lavoratori per inquadramento',
                columns: [
                    {
                        field: 'Qualifica',
                        headerName: 'Qualifica',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                    {
                        field: 'numeroLavoratoriRaggiunti',
                        headerName: 'Lavoratori Raggiunti',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                ],
                endpoint: 'statisticheFormazione/lavoratoriPerInquadramento',
            },
            {
                name: 'Lavoratori per ambito',
                columns: [
                    {
                        field: 'Ambito',
                        headerName: 'Ambito',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                    {
                        field: 'numeroLavoratoriRaggiunti',
                        headerName: 'Lavoratori Raggiunti',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                ],
                endpoint: 'statisticheFormazione/lavoratoriPerAmbito',
            },
            {
                name: 'Lavoratori-Ambiti-Inquadramento-Genere',
                columns: [
                    {
                        field: 'Ambito',
                        headerName: 'Ambito',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                    {
                        field: 'Sesso',
                        headerName: 'Genere',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                    {
                        field: 'Qualifica',
                        headerName: 'Qualifica',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                    {
                        field: 'numeroLavoratoriRaggiunti',
                        headerName: 'Lavoratori Raggiunti',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                ],
                endpoint:
                    'statisticheFormazione/lavoratoriAmbitoInquadramentoGenere',
            },
            {
                name: 'Lavoratori per tipo categoria',
                columns: [
                    {
                        field: 'TipoCategoria',
                        headerName: 'Tipo Categoria',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                    {
                        field: 'numeroLavoratoriRaggiunti',
                        headerName: 'Lavoratori Raggiunti',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                ],
                endpoint: 'statisticheFormazione/lavoratoriPerTipoCategoria',
            },
            {
                name: 'Lavoratori-TipoCategoria-Inquadramento-Genere',
                columns: [
                    {
                        field: 'TipoCategoria',
                        headerName: 'Tipo Categoria',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                    {
                        field: 'Sesso',
                        headerName: 'Genere',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                    {
                        field: 'Qualifica',
                        headerName: 'Qualifica',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                    {
                        field: 'numeroLavoratoriRaggiunti',
                        headerName: 'Lavoratori Raggiunti',
                        flex: 1,
                        align: 'center',
                        headerAlign: 'center',
                    },
                ],
                endpoint:
                    'statisticheFormazione/lavoratoriTipoCategoriaInquadramentoGenere',
            },
        ],
    },
];

const StatisticheFormazione = (props) => {
    const [mainTabIndex, setMainTabIndex] = useState(0);
    const [innerTabIndex, setInnerTabIndex] = React.useState([0, 0]);
    const [dal, setDal] = useState(
        moment(new Date()).subtract(6, 'months').format('YYYY-MM-DD')
    );
    const [al, setAl] = useState(moment(new Date()).format('YYYY-MM-DD'));

    const queryClient = React.useRef(new QueryClient()).current;

    return (
        <QueryClientProvider client={queryClient}>
            {/* filters */}
            <Grid
                container
                direction="row"
                spacing={2}
                alignItems="center"
                gap={2}
            >
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                        ampmInClock={false}
                        slotProps={{
                            textField: { size: 'small', fullWidth: true },
                        }}
                        label="Dal"
                        value={moment(dal)}
                        onChange={(newValue) => {
                            setDal(
                                newValue ? newValue.format('YYYY-MM-DD') : null
                            );
                        }}
                    />
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                        ampmInClock={false}
                        slotProps={{
                            textField: { size: 'small', fullWidth: true },
                        }}
                        label="Al"
                        value={moment(al)}
                        minDate={moment(dal)}
                        onChange={(newValue) => {
                            setAl(
                                newValue ? newValue.format('YYYY-MM-DD') : null
                            );
                        }}
                    />
                </LocalizationProvider>
            </Grid>

            {/* main tab selector */}
            <Box sx={{ width: '100%' }}>
                <Tabs
                    value={mainTabIndex}
                    onChange={async (_, newValue) => {
                        setMainTabIndex(newValue);
                    }}
                    variant="scrollable"
                >
                    {stats.map((stat, mainIndex) => (
                        <Tab
                            key={`main-${mainIndex}-${stat.name}`}
                            iconPosition="start"
                            label={stat.name}
                            id={`main-tab-${mainIndex}`}
                            aria-controls={`main-tabpanel-${mainIndex}`}
                        />
                    ))}
                </Tabs>
            </Box>

            {stats.map((stat, mainIndex) => (
                <TabPanel
                    key={mainIndex}
                    index={mainIndex}
                    value={mainTabIndex}
                >
                    {/* inner tab selector */}
                    <Box sx={{ width: '100%' }}>
                        <Tabs
                            value={innerTabIndex[mainIndex]}
                            onChange={(_, value) => {
                                setInnerTabIndex((prev) => {
                                    const newInnerTabIndex = [...prev];
                                    newInnerTabIndex[mainIndex] = value;
                                    return newInnerTabIndex;
                                });
                            }}
                            variant="scrollable"
                        >
                            {stat.inner.map((stat, innerIndex) => (
                                <Tab
                                    key={`inner-${mainIndex}-${innerIndex}-${stat.name}`}
                                    iconPosition="start"
                                    label={stat.name}
                                    id={`inner-tab-${mainIndex}-${innerIndex}`}
                                    aria-controls={`main-tabpanel-${mainIndex}-${innerIndex}`}
                                />
                            ))}
                        </Tabs>
                    </Box>

                    {/* inner tab content */}
                    {stat.inner.map((stat, innerIndex) => (
                        <TabPanel
                            key={innerIndex}
                            index={innerIndex}
                            value={innerTabIndex[mainIndex]}
                        >
                            <InnerTabContent
                                stat={stat}
                                filters={{
                                    dal: dal,
                                    al: al,
                                    cliente: props.idAzienda,
                                }}
                                ragioneSociale={props.RagioneSociale}
                            />
                        </TabPanel>
                    ))}
                </TabPanel>
            ))}
        </QueryClientProvider>
    );
};

export default StatisticheFormazione;

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 0 }}>{children}</Box>
            )}
        </div>
    );
}

function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
            >
                <GridToolbarQuickFilter placeholder="Cerca..." />
            </Grid>
        </GridToolbarContainer>
    );
}

const ExportButton = ({ stat, filters, ragioneSociale, data, rawData }) => {
    const anchorRef = useRef(null);
    const [openButton, setOpenButton] = useState(false);
    const handleToggleButton = () => {
        setOpenButton(!openButton);
    };

    const options = [
        {
            id: 'pdf',
            icon: <PictureAsPdfIcon />,
            text: 'PDF',
        },
        {
            id: 'csv',
            icon: <Dataset />,
            text: 'CSV',
        },
        {
            id: 'xls',
            icon: <Dataset />,
            text: 'Excel',
        },
        {
            id: 'esploso',
            icon: <Dataset />,
            text: 'Esploso',
        },
    ];

    return (
        <>
            {/* button */}
            <ButtonGroup
                variant="contained"
                className="ButtonMiller"
                ref={anchorRef}
                aria-label="split button"
            >
                <Button
                    startIcon={<FileDownload />}
                    variant="contained"
                    className="ButtonMiller"
                    onClick={() => {
                        handleToggleButton();
                    }}
                >
                    Esporta
                </Button>
                <Button
                    variant="contained"
                    className="ButtonMiller"
                    aria-controls={openButton ? 'split-button-menu' : undefined}
                    aria-expanded={openButton ? 'true' : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={() => {
                        handleToggleButton();
                    }}
                >
                    {openButton ? <ArrowDropUp /> : <ArrowDropDown />}
                </Button>
            </ButtonGroup>

            {/* popper (download / upload) */}
            <Popper
                sx={{
                    zIndex: 100,
                }}
                open={openButton}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
            >
                {({ TransitionProps, placement }) => (
                    <Grow {...TransitionProps}>
                        <Paper sx={{ ml: '15px' }}>
                            <ClickAwayListener
                                onClickAway={(event) => {
                                    if (
                                        anchorRef.current &&
                                        anchorRef.current.contains(event.target)
                                    ) {
                                        return;
                                    }
                                    setOpenButton(false);
                                }}
                            >
                                <MenuList id="split-button-menu" autoFocusItem>
                                    {options.map((option, index) => (
                                        <MenuItem
                                            key={option.id}
                                            onClick={() => {
                                                const filename = `Statistiche formazione - ${stat.name} - ${ragioneSociale} - ${moment(filters.dal).format('DD/MM/YYYY')} - ${moment(filters.al).format('DD/MM/YYYY')}`;

                                                if (option.id === 'pdf') {
                                                    downloadPDF(
                                                        stat,
                                                        filters,
                                                        ragioneSociale,
                                                        data
                                                    );
                                                }

                                                if (option.id === 'csv') {
                                                    if (data.length > 0) {
                                                        downloadCSV(
                                                            convertToCSV(data),
                                                            `${filename}.csv`
                                                        );
                                                    }
                                                }

                                                if (option.id === 'xls') {
                                                    if (data.length > 0) {
                                                        writeStyledExcel(
                                                            data,
                                                            filename,
                                                            `${filename}.xlsx`
                                                        );
                                                    }
                                                }

                                                if (option.id === 'esploso') {
                                                    const formattedRawData =
                                                        formatRawData(rawData);
                                                    if (formattedRawData.length > 0) {
                                                        writeStyledExcel(
                                                            formattedRawData,
                                                            `${filename} - dettaglio per persona`,
                                                            `${filename} - esploso.xlsx`
                                                        );
                                                    }
                                                }

                                                setOpenButton(false);
                                            }}
                                        >
                                            <span style={{ color: '#11526f' }}>
                                                {option.icon} {option.text}
                                            </span>
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    );
};

function formatRawData(rawData = []) {
    return rawData.map((row) => {
        const formatted = { ...row };
        ['Data', 'Data_Completamento'].forEach((field) => {
            if (formatted[field]) {
                formatted[field] = moment(formatted[field]).format(
                    'DD/MM/YYYY'
                );
            }
        });
        return formatted;
    });
}

const formatExcelHeader = (header) =>
    header
        .replaceAll('_', ' ')
        .replace(/\b\w/g, (letter) => letter.toUpperCase());

function writeStyledExcel(rows, title, fileName) {
    const headers = Object.keys(rows[0]);
    const displayHeaders = headers.map(formatExcelHeader);
    const values = rows.map((row) => headers.map((header) => row[header] ?? ''));
    const worksheet = XLSX.utils.aoa_to_sheet([
        [title],
        [`Generato il ${moment().format('DD/MM/YYYY [alle] HH:mm')}`],
        [],
        displayHeaders,
        ...values,
    ]);
    const lastColumn = Math.max(headers.length - 1, 0);

    worksheet['!merges'] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: lastColumn } },
        { s: { r: 1, c: 0 }, e: { r: 1, c: lastColumn } },
    ];
    worksheet['!autofilter'] = {
        ref: XLSX.utils.encode_range({ r: 3, c: 0 }, { r: values.length + 3, c: lastColumn }),
    };
    worksheet['!freeze'] = { xSplit: 0, ySplit: 4 };
    worksheet['!cols'] = headers.map((header, columnIndex) => ({
        wch: Math.min(
            45,
            Math.max(
                displayHeaders[columnIndex].length + 3,
                ...values.map((row) => String(row[columnIndex] ?? '').length + 2)
            )
        ),
    }));
    worksheet['!rows'] = [{ hpt: 28 }, { hpt: 20 }, { hpt: 8 }, { hpt: 24 }];

    worksheet.A1.s = {
        fill: { fgColor: { rgb: '11526F' } },
        font: { color: { rgb: 'FFFFFF' }, bold: true, sz: 16 },
        alignment: { vertical: 'center', horizontal: 'left' },
    };
    worksheet.A2.s = {
        fill: { fgColor: { rgb: 'DDEBF1' } },
        font: { color: { rgb: '44546A' }, italic: true, sz: 10 },
    };

    for (let column = 0; column <= lastColumn; column += 1) {
        const headerCell = worksheet[XLSX.utils.encode_cell({ r: 3, c: column })];
        headerCell.s = {
            fill: { fgColor: { rgb: '16749A' } },
            font: { color: { rgb: 'FFFFFF' }, bold: true },
            alignment: { vertical: 'center', horizontal: 'center', wrapText: true },
            border: { bottom: { style: 'thin', color: { rgb: 'FFFFFF' } } },
        };
        for (let row = 4; row < values.length + 4; row += 1) {
            const cell = worksheet[XLSX.utils.encode_cell({ r: row, c: column })];
            if (!cell) continue;
            cell.s = {
                fill: { fgColor: { rgb: row % 2 === 0 ? 'F2F7F9' : 'FFFFFF' } },
                alignment: { vertical: 'center', wrapText: true },
                border: { bottom: { style: 'hair', color: { rgb: 'D9E2E7' } } },
            };
        }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Dati');
    XLSX.writeFile(workbook, fileName);
}

const fetchData = async (endpoint, filters) => {
    return (
        await unsplash.get(endpoint, {
            params: {
                ...filters,
                raw: true,
                includiCessati: true,
            },
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
        })
    ).data;
};

const InnerTabContent = ({ stat, filters, ragioneSociale }) => {
    const { data, isLoading, isFetching, isError, refetch } = useQuery({
        queryKey: [stat.endpoint, filters],
        queryFn: () => fetchData(stat.endpoint, filters),
        retry: false,
        staleTime: 5 * 60e3,
        refetchOnWindowFocus: false,
    });

    return (
        <Grid item xs={12}>
            <Box
                sx={{
                    height: '60vh',
                    width: 1,
                    marginTop: '10px',
                }}
            >
                {isError ? (
                    <Alert severity="error" action={
                        <Button color="inherit" disabled={isFetching} onClick={() => refetch()}>
                            Riprova
                        </Button>
                    }>
                        Impossibile caricare le statistiche complete. Riprova tra poco.
                    </Alert>
                ) : (<>
                <ExportButton
                    stat={stat}
                    filters={filters}
                    ragioneSociale={ragioneSociale}
                    data={data?.data ?? []}
                    rawData={data?.raw}
                />

                <DataGridPro
                    initialState={{ pinnedColumns: { left: ['Actions'] } }}
                    components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooterPersonalized,
                    }}
                    slots={{
                        loadingOverlay: LinearProgress,
                    }}
                    loading={isLoading || isFetching}
                    localeText={
                        itIT.components.MuiDataGrid.defaultProps.localeText
                    }
                    rowHeight={52}
                    rows={data?.data ?? []}
                    columns={stat.columns ?? []}
                    getRowId={(row) => JSON.stringify(row)}
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                />
                </>)}
            </Box>
        </Grid>
    );
};

function convertToCSV(arr) {
    const headers = Object.keys(arr[0]);
    const rows = arr.map((obj) =>
        headers
            .map((header) => {
                const val = obj[header] ?? '';
                const escaped = String(val).replace(/"/g, '""');
                return `"${escaped}"`;
            })
            .join(',')
    );
    return [headers.join(','), ...rows].join('\r\n');
}

function downloadCSV(csv, filename) {
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

const downloadPDF = (stat, filters, ragioneSociale, data) => {
    const unit = 'pt';
    const size = 'A4'; // Use A1, A2, A3 or A4
    const orientation = 'portrait'; // portrait or landscape

    const doc = new jsPDF(orientation, unit, size);
    var img = new Image();
    img.src = require('../assets/images/Logo-ASTM.png');

    doc.addImage(img, 'PNG', 10, 10, 220, 70);
    doc.setTextColor(0, 0, 0);

    doc.setFont(undefined, 'bold');
    doc.setFontSize(13);
    doc.text(
        'PERIODO: ' +
            moment(filters.dal).format('DD/MM/YYYY') +
            ' - ' +
            moment(filters.al).format('DD/MM/YYYY'),
        255,
        55
    );
    doc.text(
        doc.splitTextToSize(
            'Azienda: ' + ragioneSociale.toUpperCase(),
            doc.internal.pageSize.getWidth() - 255
        ),
        255,
        75
    );
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(12);
    doc.setFillColor(34, 100, 174);
    doc.rect(10, 100, doc.internal.pageSize.getWidth() - 20, 30, 'F');
    doc.text(
        stat.name,
        (doc.internal.pageSize.getWidth() - doc.getTextWidth(stat.name)) / 2,
        120
    );
    doc.setTextColor(0, 0, 0);

    doc.autoTable(
        stat.columns.map((c) => c.headerName), // headers
        data.map((d) => stat.columns.map((col) => d[col.field])), // data
        {
            startY: 150,
            startX: 0,
            tableWidth: 'auto',
            columnWidth: 'auto',
            headStyles: { fillColor: [34, 100, 174] },
            footStyles: { fillColor: [34, 100, 174] },
            margin: { left: 10, right: 10 },
            showFoot: 'lastPage',
        }
    );

    doc.output('pdfobjectnewwindow', 'report');
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
